import { render, staticRenderFns } from "./DepositList.vue?vue&type=template&id=0f57e4bf&scoped=true&"
import script from "./DepositList.vue?vue&type=script&lang=js&"
export * from "./DepositList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57e4bf",
  null
  
)

export default component.exports